import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import { AppContainer } from 'react-hot-loader';
import createHistory from 'history/createBrowserHistory';
import createNewStore from 'src/redux/createNewStore';
import ReactGA from 'react-ga';
import AOS from 'aos';

import './index.css';
import App from 'src/App';
import {unregister} from './registerServiceWorker';

ReactGA.initialize('UA-142548173-1');
const onUpdate = () => {
  ReactGA.set({ page: window.location.pathname });
  ReactGA.pageview(window.location.pathname);
};

AOS.init({ duration: 700, once: true, easing: 'ease-out-cubic' });

const history = createHistory();
const store = createNewStore(history);
const render = Component => {
  ReactDOM.render(
    <AppContainer>
      <Provider store={store}>
        <ConnectedRouter onUpdate={onUpdate} history={history}>
          <Component />
        </ConnectedRouter>
      </Provider>
    </AppContainer>,
    document.getElementById('root')
  )
};
render(App);

if (module.hot) {
  module.hot.accept('src/App', () => {
    render(App);
  });
}
unregister();



// WEBPACK FOOTER //
// ./src/index.js